import { render } from "./TableGoals.vue?vue&type=template&id=0e860554"
import script from "./TableGoals.vue?vue&type=script&lang=js"
export * from "./TableGoals.vue?vue&type=script&lang=js"

import "./TableGoals.vue?vue&type=style&index=0&id=0e860554&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__